import { Modal } from "antd";
import React from "react";
import AdminForm from "../../workers/admin-details-form/AdminForm";
import OperatorAdminForm from "../../workers/admin-details-form/OperatorAdminForm";
import { useTranslation } from "react-i18next";

interface OperatorEditModalProps {
  setEditModalOpen: (open: boolean) => void;
  editModalOpen: boolean;
  item: any;
}

const OperatorEditModal: React.FC<OperatorEditModalProps> = (props) => {
  const { setEditModalOpen, editModalOpen, item } = props;
  const { t } = useTranslation();
  const handleCancel = () => {
    setEditModalOpen(false);
  };

  return (
    <Modal
      title={item?.operator?.name ? t("edit_operator") : t("set_operator")}
      open={editModalOpen}
      onCancel={handleCancel}
      destroyOnClose
      footer={null}
    >
      <OperatorAdminForm
        mutationType="edit"
        onCancel={handleCancel}
        item={item}
      />
    </Modal>
  );
};

export default OperatorEditModal;
